<template>
    <div class="order-address-plugin-form">

        <div v-show="success" class="text-container">
            <h2>Danke für deine Bestellung beim Öpfelchasper.</h2>
            <p>
                Vielen Dank für deine Bestellung beim Öpfelchasper, wir bearbeiten sie so schnell wie möglich.<br>
                Die Bestellbestätigung erhältst du schon bald per E-Mail.<br>
                <br>
                Hast du noch Fragen? Wir beantworten dir sie gerne unter <a href="tel:+41438186152">043 818 61 52</a> oder per E-Mail unter <a href="mailto:info@oepfelchasper.ch">info@oepfelchasper.ch</a>.
            </p>
        </div>

        <div v-show="error" class="text-container">
            <p>
                Deine Bestellung konnte nicht übermittelt werden.<br>
                Bitte versuche es später noch einmal oder kontaktiere uns per Telefon oder E-Mail:<br>
                <br>
                <a href="tel:+41438186152">043 818 61 52</a><br>
                <a href="mailto:info@oepfelchasper.ch">info@oepfelchasper.ch</a>
            </p>
            <p>
                <a
                    href="#"
                    class="order-address-form__link--before"
                    @click.prevent="showForm"
                >
                    Zurück
                </a>
            </p>
        </div>

        <div v-show="(!success && !error)">
            <form @submit="validateForm">
                <address-form
                    ref="addressForm"
                    :validate-form="validateForm"
                    early-invoice-text="Wir möchten unsere Bestellung vor 10 Uhr morgens erhalten.<br>Der Aufpreis für die Öpfelchasper-Frühlieferung beträgt 5 CHF pro Lieferung."
                    :firm-required="false"
                />
            </form>

            <div class="order-address-plugin-form__btn-container">
                <a
                    href="#"
                    class="btn btn-default"
                    @click.prevent="validateForm"
                >
                    Testkorb bestellen
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery'; // eslint-disable-line

import AddressForm from '../Forms/Address.vue';

export default {
    components: {
        AddressForm,
    },
    data() {
        return {
            error: false,
            success: false,
        };
    },
    methods: {
        validateForm() {
            const $heading = $('.order-address-form__heading');
            // check for errors and empty, required fields
            this.$refs.addressForm.$refs.invoiceAddress.$v.$touch();
            this.$refs.addressForm.$refs.deliveryAddress.$v.$touch();
            // if there are errors, jump to make them visible to the user
            if (this.$refs.addressForm.$refs.deliveryAddress.$v.form.$invalid ||
                this.$refs.addressForm.$refs.deliveryAddress.$v.form.$error ||
                this.$refs.addressForm.$refs.invoiceAddress.$v.form.$invalid ||
                this.$refs.addressForm.$refs.invoiceAddress.$v.form.$error
            ) {
                window.scrollTo(0, $heading.offset().top);
            } else { // if no errors, send order
                this.sendOrder();
            }
        },
        sendOrder() {
            const addressForm = this.$refs.addressForm.$refs.addressForm;
            const { invoiceAddress } = addressForm.$refs.invoiceAddress.form;
            const { deliveryAddress } = addressForm.$refs.deliveryAddress.form;

            // prepare order, save addresses
            this.$store.dispatch('prepareOrder', {
                invoiceAddress,
                deliveryAddress,
                attentionBy: addressForm.$refs.invoiceAddress.form.attention_by,
                comment: addressForm.$refs.invoiceAddress.form.comment,
            });

            // show loading modal
            this.$store.dispatch('showLoadingModal', {
                message: 'Deine Bestellung wird bearbeitet.',
            });

            // send order to whatwedo API
            this.$store.dispatch('sendOrderTestBasket').then(
                () => {
                    this.$store.dispatch('hideLoadingModal'); // hide loading
                    this.success = true;
                    this.addDataLayerEvent();
                    $('#order-plugin-header-text, #order-plugin-header-image').hide();
                },
                () => {
                    // error handling
                    this.$store.dispatch('hideLoadingModal'); // hide loading
                    this.error = true;
                    $('#order-plugin-header-text, #order-plugin-header-image').hide();
                },
            );
        },
        addDataLayerEvent() {
            if (typeof window.dataLayer !== 'undefined') {
                window.dataLayer.push({
                    event: 'test-basket-form.sent',
                });
            }
        },
        showForm() {
            this.error = false;
            $('#order-plugin-header-text, #order-plugin-header-image').show();
        },
    },
};
</script>




// WEBPACK FOOTER //
// TestBasket.vue?5f3d4e10